import { useHotkeys } from '@mantine/hooks';

/** Ctrl/Cmd+S zapisuje zmiany w edytorze — działa także podczas pisania w polach i w edytorze treści. */
export function useSaveShortcut(enabled: boolean, save: () => void) {
  useHotkeys([['mod+S', () => enabled && save()]], [], true);
}
